import { BaseQuery, TrainingInputUpdate } from 'generated/graphql';
import { mapBaseQueryFields } from './BaseQueryInputUpdateMapper';

export const mapToTrainingInputUpdate = (q: BaseQuery, assignee?: string): TrainingInputUpdate => {
  return {
    ...mapBaseQueryFields(q, assignee),
    fileName: q.queryDetails?.__typename === 'TrainingQuery' ? q.queryDetails?.fileName : '',
    xtmProjectName:
      q.queryDetails?.__typename === 'TrainingQuery' ? q.queryDetails?.xtmProjectName : ''
  };
};
